import React, { useMemo, useRef } from 'react'

import { Favorite_PageIdEnum } from 'src/api/gen'
import { useURLAndStorageState } from 'src/commons/hooks/useURLAndStorageState'
import { IFilters } from 'src/commons/types'
import { useAgencySettings, useAgencySettingsDistanceUnit, useAgencySettingsSpeedUnit } from 'src/layout/AgencySettings'
import { useProviders } from 'src/layout/hooks'
import { useMapLayer } from 'src/layout/MapLayerWrapper'
import { FilteringCard } from 'src/muiv5/components/commons/Cards/FilteringCard'
import { getInitialFilters } from 'src/pages/Dashboard'
import DashboardFilterPanel from 'src/pages/Dashboard/FilterPanel'

import TripsCharts from '../Dashboard/TripsCharts'

export default function TripsKPI() {
  const { activeProviders } = useProviders()
  const layers = useMapLayer()
  const { get_kpi_filter_range } = useAgencySettings()
  const { value: speedUnit } = useAgencySettingsSpeedUnit()
  const { value: distanceUnit } = useAgencySettingsDistanceUnit()
  const isDurationFilterEnabled = true
  const isDayOfWeekFilterEnabled = true
  const isCloseMeansOfTransportFilterEnabled = true
  const isTripTypeFilterEnabled = true
  const defaultFilters = useMemo(
    () =>
      getInitialFilters(
        layers,
        get_kpi_filter_range,
        isDurationFilterEnabled,
        distanceUnit,
        speedUnit,
        isDayOfWeekFilterEnabled,
        isCloseMeansOfTransportFilterEnabled,
        isTripTypeFilterEnabled
      ),
    [
      layers,
      get_kpi_filter_range,
      isDurationFilterEnabled,
      distanceUnit,
      speedUnit,
      isDayOfWeekFilterEnabled,
      isCloseMeansOfTransportFilterEnabled,
      isTripTypeFilterEnabled,
    ]
  )
  const [filters, setFilters] = useURLAndStorageState(Favorite_PageIdEnum.trips_KPI, defaultFilters, [
    'range',
    'endRange',
  ])
  const displayedFiltersRef = useRef<IFilters>()

  const onApplyFilter = function () {
    if (!displayedFiltersRef.current) {
      throw new Error('There are no displayed filters')
    }

    setFilters(displayedFiltersRef.current)
  }

  return (
    <FilteringCard
      SideComponent={
        <DashboardFilterPanel
          ref={displayedFiltersRef}
          initialFilters={filters}
          defaultFilters={defaultFilters}
          providers={activeProviders}
        />
      }
      onApplyFilter={onApplyFilter}
    >
      <TripsCharts filters={filters} />
    </FilteringCard>
  )
}
